/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorArticle from 'base/components/labrador/Article';

export const DynamicLabradorArticle: typeof LabradorArticle = (props) => {
    return <ErrorBoundary><LabradorArticle {...props} /></ErrorBoundary>;
}
export type DynamicLabradorArticleProps = PropsFromComponent<typeof LabradorArticle>;
